import { render, staticRenderFns } from "./MensagemIpi.vue?vue&type=template&id=0683606f&scoped=true&"
import script from "./MensagemIpi.vue?vue&type=script&lang=js&"
export * from "./MensagemIpi.vue?vue&type=script&lang=js&"
import style0 from "./MensagemIpi.vue?vue&type=style&index=0&id=0683606f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683606f",
  null
  
)

export default component.exports